import { render, staticRenderFns } from "./NewCustomFieldLabel.vue?vue&type=template&id=2a93a965&"
import script from "./NewCustomFieldLabel.vue?vue&type=script&lang=js&"
export * from "./NewCustomFieldLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a93a965')) {
      api.createRecord('2a93a965', component.options)
    } else {
      api.reload('2a93a965', component.options)
    }
    module.hot.accept("./NewCustomFieldLabel.vue?vue&type=template&id=2a93a965&", function () {
      api.rerender('2a93a965', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/NewCustomFieldLabel.vue"
export default component.exports